import InputSelect from 'Arch/components/global-components/InputSelect.vue';
import InputText from 'Arch/components/global-components/InputText.vue';
import InputUpload from 'Arch/components/global-components/InputUpload.vue';
import InputCpfCnpj from 'Arch/components/global-components/InputCpfCnpj.vue';
import InputPhone from 'Arch/components/global-components/InputPhone.vue';
import InputDate from '@/app/arch/components/global-components/InputDate.vue';
import InputPercentage from 'Arch/components/global-components/InputPercentage.vue';
import Skeleton from 'Arch/components/global-components/Skeleton.vue';
import CheckComponent from 'Arch/components/global-components/CheckComponent.vue';
import InputMoney from 'Arch/components/global-components/InputMoney.vue';
import InputRadio from 'Arch/components/global-components/InputRadio.vue';
import BtnTooltip from 'Arch/components/global-components/BtnTooltip.vue';
import VueEditorCode from 'Arch/components/global-components/VueEditorCode.vue';
import ListTags from 'Arch/components/list/ListTags.vue';
import { VueEditor } from 'vue2-editor';
import Vue from 'vue';
import Fragment from 'Arch/components/global-components/VFragment';
import InputState from 'Arch/components/global-components/InputState.vue';
import InputSelectRequest from 'Arch/components/global-components/InputSelectRequest.vue';
import PercentInput from 'vue-percent-input';

const GlobalComponents = {
  install: (VueInstance) => {
    VueInstance.component('input-select-request', InputSelectRequest);
    VueInstance.component('input-text', InputText);
    VueInstance.component('input-select', InputSelect);
    VueInstance.component('input-upload', InputUpload);
    VueInstance.component('input-mask', InputCpfCnpj);
    VueInstance.component('input-state', InputState);
    VueInstance.component('input-phone', InputPhone);
    VueInstance.component('vue-editor', VueEditor);
    VueInstance.component('input-date', InputDate);
    VueInstance.component('input-percentage', InputPercentage);
    VueInstance.component('skeleton', Skeleton);
    VueInstance.component('check-icon', CheckComponent);
    VueInstance.component('input-money', InputMoney);
    VueInstance.component('input-radio', InputRadio);
    VueInstance.component('btn-tooltip', BtnTooltip);
    VueInstance.component('editor-code', VueEditorCode);
    VueInstance.component('list-tags', ListTags);
    VueInstance.component('fragment', Fragment);
  },
};

Vue.use(PercentInput);
Vue.use(GlobalComponents);

export default GlobalComponents;
